import React, { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import Table from "../../../core/common/dataTable/index";
import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
import {fetchAllPaySlipReportDetails,fetchAllPaySlipReportDetailsMonthly} from "../../../core/data/redux/reports/paySlip_report/payslipAction";
import { useSelector, useDispatch } from "react-redux";
import { AppDispatch } from "../../../core/data/redux/store";
import { filterData } from "../../../core/common/GlobalFunctions/tableFilters";
import { exportToExcel } from "../../../core/common/GlobalFunctions/exportTableData";
import { exportToCSV } from "../../../core/common/GlobalFunctions/exportTableData";
import { fetchSalaryTransactions } from "../../../core/data/redux/payroll/payrollSalary/salaryTransaction/salaryTransactionActions";

interface SalaryReportProps {
  showOnlyTable?: boolean;
}

const SalaryReport: React.FC<SalaryReportProps> = ({showOnlyTable}) => {
    const [selectedYear, setSelectedYear] = useState("2025");
    const [selectedSort, setSelectedSort] = useState<any>("Recently Added");
    const { salaryTransactions } = useSelector((state: any) => state.payroll.salaryTransaction);
    
    const dispatch = useDispatch<AppDispatch>();
    const [list, setlist] = useState<any>(null);
    const [details, setdetails] = useState<any>(null);
    const [monthlyDetails, setmonthlyDetails] = useState<any>(null);
    const [tableKey, setTableKey] = useState(0);

    useEffect(() => {
        if (selectedYear) {
            dispatch(fetchAllPaySlipReportDetailsMonthly(selectedYear))
                .then((res: any) => {
                    const data = res.payload.data;
                    setmonthlyDetails(data);
                })
                .catch((err: any) => {
                    console.error("Failed to fetch payslip data:", err);
                });
        }
    }, [dispatch, selectedYear]);


    useEffect(() => {
        dispatch(fetchAllPaySlipReportDetails()).then((res) => {
            setdetails(res.payload.data);
        });
        if (!salaryTransactions?.length) {
            dispatch(fetchSalaryTransactions({}));
        }
    }, []);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const data = salaryTransactions ? salaryTransactions : [];

    function filterSalaryTransactionData(data: any[]) {
  return data.map(item => ({
    employeeName: item.EmployeeName || "N/A",
    employeeNumber: item.EmployeeNumber || "N/A",
    pictureURL: item.PictureURL || null,

    salary: item.salary || "0.00",
    netSalary: item.net_salary || "0.00",
    totalEarnings: item.total_earnings || "0.00",
    totalDeductions: item.total_deductions || "0.00",

    paymentDate: item.payment_date ? new Date(item.payment_date).toLocaleDateString() : "N/A",
    month: item.month_name || "N/A",
    year: item.year || "N/A",
    status: item.status || "N/A",

    // earnings: item.earnings_json?.map((e: any) => ({
    //   name: e.name,
    //   amount: e.amount
    // })) || [],

    // deductions: item.deductions_json?.map((d: any) => ({
    //   name: d.name,
    //   amount: d.proratedAmount ?? d.originalAmount ?? 0
    // })) || [],
  }));
}

const data2 = filterSalaryTransactionData(data)

    useEffect(() => {
        setTableKey((prevKey) => prevKey + 1);
    }, [dispatch, list, data, details, selectedSort]);

    const filteredData = useMemo(() => {
        return filterData(data || [], {}, "CreatedAt", "CreatedAt", selectedSort);
    }, [dispatch, data, list, selectedSort]);

    const transcationColumns = [
        {
            title: "Emp ID",
            dataIndex: "EmployeeNumber",
            sorter: (a: any, b: any) => a.EmployeeNumber.length - b.EmployeeNumber.length,
        },
        {
            title: "Name",
            dataIndex: "EmployeeName",
            render: (text: string, record: any) => (
                <div className="d-flex align-items-center file-name-icon">
                    <div className="avatar avatar-md">
                        <img
                            src={record.PictureURL ?? "https://cdn-icons-png.flaticon.com/512/149/149071.png"}
                            alt="img"
                            className="img-fluid rounded-circle"
                        />
                    </div>
                    <div className="ms-2">
                        <h6 className="fw-medium">
                            <Link to="#">{record.EmployeeName}</Link>
                        </h6>
                    </div>
                </div>
            ),
            sorter: (a: any, b: any) => a.EmployeeName.length - b.EmployeeName.length,
        },

        {
            title: "Status",
            dataIndex: "status",
            sorter: (a: any, b: any) => {
                const statusOrder = ['pending', 'processed'];
                return statusOrder.indexOf(a.status) - statusOrder.indexOf(b.status);
            },
            render: (status: string) => {
                let color = '';
                let text = '';

                if (status === 'Processed') {
                    color = 'green';
                    text = 'Processed';
                } else if (status === 'Pending') {
                    color = 'orange';
                    text = 'Pending';
                }

                return (
                    <span style={{ color: color }}>
                        {text}
                    </span>
                );
            }
        },

        {
            title: "Leaves Taken",
            dataIndex: "leaves_taken",
            sorter: (a: any, b: any) => a.leaves_taken - b.leaves_taken,
        },
        {
            title: "Balance Leave",
            dataIndex: "balance_leave",
            sorter: (a: any, b: any) => a.balance_leave - b.balance_leave,
        },
        {
            title: "Present",
            dataIndex: "total_attendance_count",
            sorter: (a: any, b: any) => a.total_attendance_count - b.total_attendance_count,
        },
        {
            title: "Leave Deduction",
            dataIndex: "leave_deduction",
            sorter: (a: any, b: any) => a.leave_deduction - b.leave_deduction,
        },
        {
            title: "Overtime Hours",
            dataIndex: "overtime_hours",
            sorter: (a: any, b: any) => a.overtime_hours - b.overtime_hours,
            render: (text: any) => (text !== undefined && text !== null) ? text : 0,
        },

        {
            title: "Earnings",
            dataIndex: "earnings_json",
            render: (text: any) => (
                <div>
                    {text && text.length > 0 ? (
                        text.map((earning: any) => (
                            <div key={earning.id}>
                                <span>
                                    {earning?.name || "None"}: ₹{earning?.amount ? earning.amount.toLocaleString() : "0"}
                                </span>
                            </div>
                        ))
                    ) : (
                        <span>₹0</span>
                    )}
                </div>
            ),
        },
        {
            title: "Deductions",
            dataIndex: "deductions_json",
            render: (text: any) => (
                <div>
                    {text && text.length > 0 ? (
                        text.map((deduction: any) => (
                            <div key={deduction.id}>
                                <span>
                                    {deduction?.name || "None"}: ₹{deduction?.amount ? deduction.amount.toLocaleString() : "0"}
                                </span>
                            </div>
                        ))
                    ) : (
                        <span>₹0</span>
                    )}
                </div>
            ),
        },
        {
            title: "Overtime Pay",
            dataIndex: "overtime_pay",
            sorter: (a: any, b: any) => a.overtime_pay - b.overtime_pay,
            render: (text: any) => (
                <span style={{ color: "#E67E22", fontWeight: "bold" }}>
                    ₹{text?.toLocaleString()}
                </span>
            ),
        },
        {
            title: "Net Salary",
            dataIndex: "net_salary",
            sorter: (a: any, b: any) => a.net_salary - b.net_salary,
            render: (text: any) => (
                <span style={{ color: "#27AE60", fontWeight: "bold" }}>
                    ₹{text?.toLocaleString()}
                </span>
            ),
        },

    ];


    useEffect(() => {
        const netPayablePerMonth = new Array(12).fill(0);

        if (monthlyDetails && monthlyDetails.length > 0) {
            monthlyDetails.forEach(({ month, net_payable }: any) => {
                netPayablePerMonth[month - 1] = parseFloat(net_payable);
            });
        }

        setpayslipchart((prev: any) => ({
            ...prev,
            series: [
                {
                    ...prev.series[0],
                    data: netPayablePerMonth,
                },
            ],
        }));
    }, [monthlyDetails]);

    const [payslipchart, setpayslipchart] = useState<any>({
        series: [
            {
                data: new Array(12).fill(0),
            },
        ],
        chart: {
            type: "line",
            height: 200,
        },
        xaxis: {
            categories: [
                "Jan",
                "Feb",
                "Mar",
                "Apr",
                "May",
                "Jun",
                "Jul",
                "Aug",
                "Sep",
                "Oct",
                "Nov",
                "Dec",
            ],
            labels: {},
        },
        stroke: {
            curve: "stepline",
        },
        dataLabels: {
            enabled: false,
        },
        markers: {
            hover: {
                sizeOffset: 4,
            },
        },
        colors: ["#FF5733"],
    });


    if (showOnlyTable) {
  return (
 <Table
  key={tableKey}
  dataSource={filteredData}
  columns={transcationColumns}
  Selection={false}
/>
  );
}
    return (
        <>
            {/* Page Wrapper */}
            <div className="page-wrapper">
                <div className="content">
                    {/* Breadcrumb */}
                    <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
                        <div className="my-auto mb-2">
                            <h2 className="mb-1">Salary Report</h2>
                            <nav>
                                <ol className="breadcrumb mb-0">
                                    <li className="breadcrumb-item">
                                        <Link to="index.html">
                                            <i className="ti ti-smart-home" />
                                        </Link>
                                    </li>
                                    <li className="breadcrumb-item">HR</li>
                                    <li className="breadcrumb-item active" aria-current="page">
                                        Salary Report
                                    </li>
                                </ol>
                            </nav>
                        </div>
                        <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
                            <div className="mb-2">
                                <div className="dropdown">
                                    <Link
                                        to="#"
                                        className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                                        data-bs-toggle="dropdown"
                                    >
                                        <i className="ti ti-file-export me-1" />
                                        Export
                                    </Link>
                                    <ul className="dropdown-menu  dropdown-menu-end p-3">
                                        <li>
                                            <button
                                                onClick={() => exportToCSV(data2, "Salary_report")}
                                                className="dropdown-item rounded-1"
                                            >
                                                <i className="ti ti-file-type-pdf me-1" />
                                                Export as CSV
                                            </button>
                                        </li>
                                        <li>
                                            <button
                                                onClick={() => exportToExcel(data2, "Salary_report")}
                                                className="dropdown-item rounded-1"
                                            >
                                                <i className="ti ti-file-type-xls me-1" />
                                                Export as Excel{" "}
                                            </button>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div className="head-icons ms-2">
                                <CollapseHeader />
                            </div>
                        </div>
                    </div>
                    {/* /Breadcrumb */}
                    {/* <div className="row">
                        <div className="col-xl-6 d-flex">
                            <div className="row flex-fill">
                                <div className="col-md-6 d-flex">
                                    <div className="card flex-fill">
                                        <div className="card-body">
                                            <div className="d-flex align-items-center justify-content-between bg-light border rounded p-2 mb-2">
                                                <div className="">
                                                    <span className="fs-14 fw-normal text-truncate mb-1">
                                                        Total Paid
                                                    </span>
                                                    <h5>
                                                        {Number(details?.[0]?.net_payable) +
                                                            Number(details?.[0]?.total_allowances)}
                                                    </h5>
                                                </div>
                                                <Link
                                                    to="#"
                                                    className="avatar avatar-md avatar-rounded bg-transparent-primary border border-primary"
                                                >
                                                    <span className="text-primary">
                                                        <i className="ti ti-brand-shopee" />
                                                    </span>
                                                </Link>
                                            </div>
                                            <p className="fs-12 fw-normal d-flex align-items-center text-truncate">
                                                <span className="text-success fs-12 d-flex align-items-center me-1">
                                                    <i className="ti ti-arrow-wave-right-up me-1" />
                                                    +20.01%
                                                </span>{" "}
                                                from last week
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6 d-flex">
                                    <div className="card flex-fill">
                                        <div className="card-body">
                                            <div className="d-flex align-items-center justify-content-between bg-light border rounded p-2 mb-2">
                                                <div className="">
                                                    <span className="fs-14 fw-normal text-truncate mb-1">
                                                        Deductions
                                                    </span>
                                                    <h5>{details?.[0].total_deductions}</h5>
                                                </div>
                                                <Link
                                                    to="#"
                                                    className="avatar avatar-md avatar-rounded bg-transparent-danger border border-danger"
                                                >
                                                    <span className="text-danger">
                                                        <i className="ti ti-brand-shopee" />
                                                    </span>
                                                </Link>
                                            </div>
                                            <p className="fs-12 fw-normal d-flex align-items-center text-truncate">
                                                <span className="text-success fs-12 d-flex align-items-center me-1">
                                                    <i className="ti ti-arrow-wave-right-up me-1" />
                                                    +17.01%
                                                </span>{" "}
                                                from last week
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6 d-flex">
                                    <div className="card flex-fill">
                                        <div className="card-body">
                                            <div className="d-flex align-items-center justify-content-between bg-light border rounded p-2 mb-2">
                                                <div className="">
                                                    <span className="fs-14 fw-normal text-truncate mb-1">
                                                        Net Pay
                                                    </span>
                                                    <h5>{details?.[0].net_payable}</h5>
                                                </div>
                                                <Link
                                                    to="#"
                                                    className="avatar avatar-md avatar-rounded bg-transparent-success border border-success"
                                                >
                                                    <span className="text-success">
                                                        <i className="ti ti-brand-shopee" />
                                                    </span>
                                                </Link>
                                            </div>
                                            <p className="fs-12 fw-normal d-flex align-items-center text-truncate">
                                                <span className="text-success fs-12 d-flex align-items-center me-1">
                                                    <i className="ti ti-arrow-wave-right-up me-1" />
                                                    +10.01%
                                                </span>{" "}
                                                from last week
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6 d-flex">
                                    <div className="card flex-fill">
                                        <div className="card-body">
                                            <div className="d-flex align-items-center justify-content-between bg-light border rounded p-2 mb-2">
                                                <div className="">
                                                    <span className="fs-14 fw-normal text-truncate mb-1">
                                                        Allowances
                                                    </span>
                                                    <h5>{details?.[0].total_allowances}</h5>
                                                </div>
                                                <Link
                                                    to="#"
                                                    className="avatar avatar-md avatar-rounded bg-transparent-skyblue border border-skyblue"
                                                >
                                                    <span className="text-skyblue">
                                                        <i className="ti ti-brand-shopee" />
                                                    </span>
                                                </Link>
                                            </div>
                                            <p className="fs-12 fw-normal d-flex align-items-center text-truncate">
                                                <span className="text-danger fs-12 d-flex align-items-center me-1">
                                                    <i className="ti ti-arrow-wave-right-up me-1" />
                                                    -10.01%
                                                </span>{" "}
                                                from last week
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                       
                        <div className="col-xl-6 d-flex">
                            <div className="card flex-fill">
                                <div className="card-header border-0 pb-0">
                                    <div className="d-flex flex-wrap justify-content-between align-items-center">
                                        <div className="d-flex align-items-center ">
                                            <span className="me-2">
                                                <i className="ti ti-chart-area-line text-danger" />
                                            </span>
                                            <h5>Salary</h5>
                                        </div>
                                        <div className="dropdown">
                                            <Link
                                                to="#"
                                                className="dropdown-toggle btn btn-sm fs-12 btn-white d-inline-flex align-items-center"
                                                data-bs-toggle="dropdown"
                                            >
                                                {selectedYear}
                                            </Link>
                                            <ul className="dropdown-menu  dropdown-menu-end p-2">
                                                <li>
                                                    <Link
                                                        to="#"
                                                        className="dropdown-item rounded-1"
                                                        onClick={() => handleYearSelect("2025")}
                                                    >
                                                        2025
                                                    </Link>
                                                </li>
                                                <li>
                                                    <Link
                                                        to="#"
                                                        className="dropdown-item rounded-1"
                                                        onClick={() => handleYearSelect("2024")}
                                                    >
                                                        2024
                                                    </Link>
                                                </li>
                                                <li>
                                                    <Link
                                                        to="#"
                                                        className="dropdown-item rounded-1"
                                                        onClick={() => handleYearSelect("2023")}
                                                    >
                                                        2023
                                                    </Link>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-body py-0">
                                    <ReactApexChart
                                        id="payslip-chart"
                                        options={payslipchart}
                                        series={payslipchart.series}
                                        type="line"
                                        height={215}
                                    />
                                </div>
                            </div>
                        </div>
                    </div> */}
                    <div className="card">
                        <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                            <h5>Salary List</h5>
                            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">
                                <div className="me-3"></div>
                                <div className="dropdown">
                                    <Link
                                        to="#"
                                        className="dropdown-toggle btn btn-sm btn-white d-inline-flex align-items-center"
                                        data-bs-toggle="dropdown"
                                    >
                                        {selectedSort
                                            ? `Sort By : ${selectedSort}`
                                            : "Sort By : Last 7 Days"}
                                    </Link>
                                    <ul className="dropdown-menu dropdown-menu-end p-3">
                                        <li>
                                            <Link
                                                to="#"
                                                onClick={() => setSelectedSort("Recently Added")}
                                                className="dropdown-item rounded-1"
                                            >
                                                Recently Added
                                            </Link>
                                        </li>
                                        <li>
                                            <Link
                                                to="#"
                                                onClick={() => setSelectedSort("Ascending")}
                                                className="dropdown-item rounded-1"
                                            >
                                                Ascending
                                            </Link>
                                        </li>
                                        <li>
                                            <Link
                                                to="#"
                                                onClick={() => setSelectedSort("Descending")}
                                                className="dropdown-item rounded-1"
                                            >
                                                Descending
                                            </Link>
                                        </li>
                                        <li>
                                            <Link
                                                to="#"
                                                onClick={() => setSelectedSort("Last Month")}
                                                className="dropdown-item rounded-1"
                                            >
                                                Last Month
                                            </Link>
                                        </li>
                                        <li>
                                            <Link
                                                to="#"
                                                onClick={() => setSelectedSort("Last 7 Days")}
                                                className="dropdown-item rounded-1"
                                            >
                                                Last 7 Days
                                            </Link>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="card-body p-0">
                            <Table
                                key={tableKey}
                                dataSource={filteredData}
                                columns={transcationColumns}
                                Selection={false}
                            />
                        </div>
                    </div>
                </div>
                <div className="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3">
                    <p className="mb-0">2024 - 2025© hrmtree.</p>
                    <p>
                        Developed By{" "}
                        <Link to="#" className="text-primary">
                            Leadchain Systems
                        </Link>
                    </p>
                </div>
            </div>
            {/* /Page Wrapper */}
        </>
    );
};

export default SalaryReport;
